// extracted by mini-css-extract-plugin
export default {"modalConsent":"modalConsent__65Ipb","modalConsentOverlay":"modalConsentOverlay__9osKh","buttonSet":"buttonSet__0PeKU","btnReject":"btnReject__fxcEj","btnAccept":"btnAccept__R+JX7"};